var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarLogout3Linear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5537 16C15.543 17.74 15.4568 18.6824 14.7742 19.2968C13.9928 20 12.7359 20 10.2221 20L9.33325 20C6.81858 20 5.56168 20 4.78035 19.2968C3.9999 18.5944 3.9999 17.4624 3.9999 15.2L3.9999 8.8C3.9999 6.5376 3.9999 5.4056 4.78035 4.7032C5.56258 4 6.81858 4 9.33325 4L10.2221 4C12.7359 4 13.9928 4 14.7742 4.7032C15.4568 5.3176 15.543 6.26 15.5537 8",
    stroke: "#E9FE53",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 6C17.6507 6 18.6987 6 19.3493 6.5856C20 7.172 20 8.1144 20 10L20 14C20 15.8856 20 16.8288 19.3493 17.4144C18.6987 18 17.6507 18 15.5555 18",
    stroke: "#E9FE53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33323 12.0002L17.3333 12.0002M17.3333 12.0002L15.5555 10.4002M17.3333 12.0002L15.5555 13.6002",
    stroke: "#E9FE53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarLogout3Linear);
export default __webpack_public_path__ + "static/media/solar_logout-3-linear.ab5dd49e9a0775d8e5c910f443f5e571.svg";
export { ForwardRef as ReactComponent };